/* MXDVS email check, assets/mxdvs-email-check.js (05.10.2026)
   One shared check for every email field on the store. Loaded on every page by
   sections/mxdvs-footer-newsletter.liquid and on the password page by layout/password.liquid.

   1. Tidy (every email field): the moment someone leaves the field, presses Enter or sends, spaces, a dot or comma
      at the end ("max@mxdvs.co."), a comma instead of a dot ("gmail,com"), double dots ("gmail..com") and capitals
      after the @ are fixed. After a fix it fires an "input" event, so the form's own stitches and ticks update.
   2. Check before sending (approved demo 05.10.2026): a clear message per mistake, shown in the form's own message
      line, and "Did you mean ...?" for typos in common mail providers with two buttons: Use (fixes the address and
      sends) and Keep mine (sends it exactly as typed). Nothing is sent while a message or suggestion shows.
      Notify me (product page), the newsletter window and the footer sign-up use their own message lines.
      Any other form with an email field gets a small message line under the field.
   For other scripts: window.MxEmail.check(value) returns { ok, value, reason, suggestion }, window.MxEmail.clean(value)
   returns the tidied address. Add data-mx-email-skip to a field to leave it alone. */
(function () {
  if (window.MxEmail) return;

  var TYPO = {
    'gmial.com': 'gmail.com', 'gmal.com': 'gmail.com', 'gamil.com': 'gmail.com', 'gnail.com': 'gmail.com',
    'gmail.co': 'gmail.com', 'gmail.cm': 'gmail.com', 'gmail.con': 'gmail.com', 'gmaill.com': 'gmail.com',
    'hotmial.com': 'hotmail.com', 'hotmal.com': 'hotmail.com', 'hotmail.co': 'hotmail.com', 'hotmail.con': 'hotmail.com',
    'outlok.com': 'outlook.com', 'outloo.com': 'outlook.com', 'outlook.co': 'outlook.com', 'outlook.con': 'outlook.com',
    'yaho.com': 'yahoo.com', 'yahooo.com': 'yahoo.com', 'yahoo.co': 'yahoo.com', 'yahoo.con': 'yahoo.com',
    'icloud.co': 'icloud.com', 'icoud.com': 'icloud.com', 'iclod.com': 'icloud.com', 'icloud.con': 'icloud.com',
    'telnet.be': 'telenet.be', 'telenet.b': 'telenet.be', 'skynet.b': 'skynet.be', 'proximus.b': 'proximus.be'
  };
  var END_TYPO = { con: 'com', cmo: 'com', comm: 'com', ocm: 'com', vom: 'com', xom: 'com' };

  function clean(v) {
    v = String(v == null ? '' : v).replace(/\s+/g, '').replace(/[.,;:]+$/, '');
    var at = v.lastIndexOf('@');
    if (at < 1) return v;
    var local = v.slice(0, at), domain = v.slice(at + 1).toLowerCase();
    domain = domain.replace(/,/g, '.').replace(/\.{2,}/g, '.').replace(/^\.+|\.+$/g, '');
    return local + '@' + domain;
  }
  function suggest(v) {
    var at = v.lastIndexOf('@'); if (at < 1) return '';
    var local = v.slice(0, at), domain = v.slice(at + 1);
    if (TYPO[domain]) return local + '@' + TYPO[domain];
    var dot = domain.lastIndexOf('.'), end = dot > -1 ? domain.slice(dot + 1) : '';
    if (END_TYPO[end]) return local + '@' + domain.slice(0, dot + 1) + END_TYPO[end];
    return '';
  }
  function check(raw) {
    var v = clean(raw);
    if (!v) return { ok: false, value: v, reason: 'Type your email address first.', suggestion: '' };
    var p = v.split('@');
    if (p.length !== 2 || !p[0] || !p[1]) return { ok: false, value: v, reason: 'An email address needs one @.', suggestion: '' };
    if (/^\.|\.$|\.\./.test(p[0]) || !/^[^\s@"(),:;<>\[\]\\]+$/.test(p[0])) return { ok: false, value: v, reason: 'Check the part before the @.', suggestion: '' };
    var labels = p[1].split('.');
    if (labels.length < 2) return { ok: false, value: v, reason: 'The address is missing its ending, like .com or .be.', suggestion: '' };
    for (var i = 0; i < labels.length; i++) {
      if (!/^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/.test(labels[i])) return { ok: false, value: v, reason: 'Check the part after the @.', suggestion: '' };
    }
    if (!/^[a-z]{2,24}$/.test(labels[labels.length - 1])) return { ok: false, value: v, reason: 'Check the ending after the last dot.', suggestion: '' };
    return { ok: true, value: v, reason: '', suggestion: suggest(v) };
  }
  window.MxEmail = { clean: clean, check: check, suggest: suggest };

  /* ---------- 1. tidy every email field ---------- */
  var SEL = 'input[type="email"], input[autocomplete~="email"], input[name*="email" i], input[data-email]';
  function isEmailField(el) {
    return !!(el && el.tagName === 'INPUT' && el.type !== 'hidden' && el.type !== 'checkbox' && el.type !== 'radio' &&
      !el.hasAttribute('data-mx-email-skip') && el.matches && el.matches(SEL));
  }
  function tidy(el) {
    if (!isEmailField(el)) return;
    var before = el.value, after = clean(before);
    if (after === before) return;
    el.value = after;
    try { el.dispatchEvent(new Event('input', { bubbles: true })); } catch (e) {}
  }

  /* ---------- 2. check before sending ---------- */
  var css = '.mx-sug{font-family:"Roboto Mono",ui-monospace,Menlo,monospace;font-size:12px;line-height:1.5;border:1px solid currentColor;border-radius:5px;padding:8.5px;margin:8.5px 0;text-align:left}' +
    '.mx-sug b{font-weight:700}.mx-sug__row{display:flex;flex-wrap:wrap;gap:8px;margin-top:8px}' +
    '.mx-sug button{font:inherit;font-weight:700;text-transform:uppercase;letter-spacing:0;border:1px solid currentColor;border-radius:5px;padding:5px 9px;cursor:pointer;background:transparent;color:inherit}' +
    '.mx-sug button[data-mx-use]{box-shadow:inset 0 0 0 1px currentColor}' +
    '.mx-email-msg{font-family:"Roboto Mono",ui-monospace,Menlo,monospace;font-size:12px;line-height:1.5;color:#e3000f;margin:6px 0 0}';
  function addCss() {
    if (document.getElementById('mx-email-css')) return;
    var s = document.createElement('style'); s.id = 'mx-email-css'; s.textContent = css; (document.head || document.documentElement).appendChild(s);
  }
  function txt(el, t) { el.textContent = t; return el; }

  /* Each known form: how to find its field, where its message line is, and where the suggestion goes */
  var FORMS = [
    { /* Notify me panel on the product page */
      click: '[data-act="alert-send"]',
      field: function (btn) { var s = btn.closest('.pp-sa__form') || btn.closest('.pp-dialog') || document; return s.querySelector('[data-email]'); },
      say: function (inp, t) {
        var nl = inp.closest('[data-nl]'), err = nl && nl.querySelector('[data-err]'); if (!err) return false;
        nl.classList.add('is-error'); err.innerHTML = '<i class="pp-nl__cross"></i><span></span>'; txt(err.lastChild, t); return true;
      },
      after: function (inp) { return inp.closest('[data-nl]') || inp.parentNode; }
    },
    { /* Newsletter window (10%) */
      form: function (f) { return f.closest('[data-mxnl]'); },
      field: function (f) { return f.querySelector('[data-mxnl-email]'); },
      say: function (inp, t) {
        var root = inp.closest('[data-mxnl]'), m = root && root.querySelector('[data-mxnl-msg]'); if (!m) return false;
        m.classList.add('is-err'); m.setAttribute('data-t', '> error: ' + t); txt(m, '> error: ' + t); return true;
      },
      after: function (inp) { var root = inp.closest('[data-mxnl]'); return (root && root.querySelector('[data-mxnl-msg]')) || inp.parentNode; }
    },
    { /* Footer sign-up (the thread) */
      form: function (f) { return f.querySelector('[data-ft-thread]'); },
      field: function (f) { var th = f.querySelector('[data-ft-thread]'); return th && th.querySelector('input[type="email"], input[name*="email" i]'); },
      say: function (inp, t) {
        var th = inp.closest('[data-ft-thread]'), out = th && th.querySelector('[data-thread-error]'), tx = th && th.querySelector('[data-thread-error-text]');
        if (!out || !tx) return false;
        tx.textContent = t; out.hidden = false; th.classList.remove('is-sending'); th.classList.add('is-error'); inp._mxSaid = th; return true;
      },
      unsay: function (inp) {
        var th = inp._mxSaid; if (!th) return; inp._mxSaid = null;
        var out = th.querySelector('[data-thread-error]'); if (out) out.hidden = true; th.classList.remove('is-error');
      },
      after: function (inp) { return inp.closest('[data-ft-thread]') || inp.parentNode; }
    },
    { /* Any other form with an email field */
      form: function () { return true; },
      field: function (f) { var list = f.querySelectorAll(SEL); for (var i = 0; i < list.length; i++) if (isEmailField(list[i])) return list[i]; return null; },
      say: function (inp, t) {
        var box = inp._mxMsg;
        if (!box) { box = document.createElement('p'); box.className = 'mx-email-msg'; box.setAttribute('role', 'alert'); inp._mxMsg = box; }
        var host = inp.parentNode; host.parentNode ? host.parentNode.insertBefore(box, host.nextSibling) : host.appendChild(box);
        txt(box, t); return true;
      },
      unsay: function (inp) { if (inp._mxMsg && inp._mxMsg.parentNode) inp._mxMsg.parentNode.removeChild(inp._mxMsg); },
      after: function (inp) { return inp.parentNode; }
    }
  ];

  function dropSug(inp) { if (inp._mxSug && inp._mxSug.parentNode) inp._mxSug.parentNode.removeChild(inp._mxSug); inp._mxSug = null; }
  function offer(inp, kind, r, resend) {
    addCss(); dropSug(inp);
    var box = document.createElement('div');
    box.className = 'mx-sug'; box.setAttribute('role', 'status');
    box.appendChild(document.createTextNode('Did you mean '));
    box.appendChild(txt(document.createElement('b'), r.suggestion));
    box.appendChild(document.createTextNode('?'));
    var row = document.createElement('div'); row.className = 'mx-sug__row';
    var use = txt(document.createElement('button'), 'Use ' + r.suggestion.split('@')[1]); use.type = 'button'; use.setAttribute('data-mx-use', '');
    var keep = txt(document.createElement('button'), 'Keep mine'); keep.type = 'button';
    row.appendChild(use); row.appendChild(keep); box.appendChild(row);
    var anchor = kind.after(inp);
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(box, anchor.nextSibling); else inp.parentNode.appendChild(box);
    inp._mxSug = box;
    use.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      inp.value = r.suggestion; inp._mxKeep = '';
      try { inp.dispatchEvent(new Event('input', { bubbles: true })); } catch (er) {}
      dropSug(inp); resend();
    });
    keep.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      inp._mxKeep = r.value; dropSug(inp); resend();
    });
    try { use.focus({ preventScroll: true }); } catch (er) {}
  }
  /* true = let the form send, false = stopped with a message or a suggestion */
  function gate(inp, kind, resend) {
    if (!inp || inp.hasAttribute('data-mx-email-skip')) return true;
    tidy(inp);
    var r = check(inp.value);
    if (!r.ok) {
      dropSug(inp);
      if (!kind.say(inp, r.reason)) FORMS[FORMS.length - 1].say(inp, r.reason);
      inp._mxKind = kind;
      try { inp.focus({ preventScroll: true }); } catch (er) {}
      return false;
    }
    if (r.suggestion && inp._mxKeep !== r.value) { inp._mxKind = kind; offer(inp, kind, r, resend); return false; }
    return true;
  }
  function stop(e) { e.preventDefault(); e.stopImmediatePropagation(); }

  /* capture phase: runs before the form's own click, Enter and submit handlers */
  document.addEventListener('focusout', function (e) { tidy(e.target); }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Enter') tidy(e.target); }, true);
  document.addEventListener('input', function (e) {
    var inp = e.target; if (!isEmailField(inp)) return;
    if (inp._mxKeep && inp._mxKeep !== clean(inp.value)) inp._mxKeep = '';
    dropSug(inp);
    var k = inp._mxKind; if (k && k.unsay) k.unsay(inp);
  }, true);
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest(FORMS[0].click) : null;
    if (!btn) return;
    var inp = FORMS[0].field(btn);
    if (!gate(inp, FORMS[0], function () { btn.click(); })) stop(e);
  }, true);
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f || !f.querySelectorAll) return;
    Array.prototype.forEach.call(f.querySelectorAll(SEL), tidy);
    for (var i = 1; i < FORMS.length; i++) {
      var kind = FORMS[i]; if (!kind.form(f)) continue;
      var inp = kind.field(f); if (!inp) return;
      if (!gate(inp, kind, function () {
        if (f.requestSubmit) f.requestSubmit();
        else f.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      })) stop(e);
      return;
    }
  }, true);
})();